import { CONFIG_TRUSTARC_DOMAIN } from '@src/config/env'
import { COUNTRY_LANGUAGES, DEFAULT_COUNTRY } from '@src/config/i18n.config'
import { TelemetryIntegration } from '@src/telemetry/telemetry-events.types'
import { getLocalisationDataFromStorage } from '@src/utils/general.utils'
import { parseLocale } from '@src/utils/i18n.utils'

import { initializeScript } from '../provider-utils/initialize-script'

export let isTrustARCScriptLoading = true
export let resolveTrustArcInitialisePromise: (value: unknown) => void
export const initialiseTrustARCPromise = new Promise(resolve => {
  resolveTrustArcInitialisePromise = resolve // Store the resolver for later use
})

export const getTrustArcLanguageCode = (): string => {
  try {
    const localisationData = getLocalisationDataFromStorage()
    if (localisationData?.locale) {
      const { language, country } = parseLocale(localisationData.locale)
      return `${language}_${country?.toLowerCase()}`
    }

    return COUNTRY_LANGUAGES[DEFAULT_COUNTRY][0]
  } catch (error) {
    console.error('Error getting TrustArc language code:', error)
    return COUNTRY_LANGUAGES[DEFAULT_COUNTRY][0]
  }
}

export const TRUSTARC_CONFIG: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
  },
  initialize: async () => {
    await initializeScript({
      key: 'trustarc',
      domain: 'https://consent.trustarc.com',
      path: () => {
        const languageCode = getTrustArcLanguageCode()
        return `/notice?domain=${CONFIG_TRUSTARC_DOMAIN}&c=teconsent&js=nj&noticeType=bb&gtm=1&language=${languageCode}`
      },
      injectAt: 'beforeFirstScript',
      onLoad: () => {
        console.log('TrustArc script loaded')
        resolveTrustArcInitialisePromise(null)
        isTrustARCScriptLoading = false
      },
    })
  },
}
